import { render, staticRenderFns } from "./Reg.vue?vue&type=template&id=4687f651&scoped=true&"
import script from "./Reg.vue?vue&type=script&lang=js&"
export * from "./Reg.vue?vue&type=script&lang=js&"
import style0 from "./Reg.vue?vue&type=style&index=0&id=4687f651&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4687f651",
  null
  
)

export default component.exports